import { Route, Switch } from "react-router";
import UsageTable from "./UsageTable";

export default () => (
  <Switch>
    <Route exact path="/inventory/usage" component={UsageTable} />
  </Switch>
);
